<template>
<!-- 新建生产单 -->
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="生产、工艺" name="first">
          <product-order-header-info ref="orderHeaderInfo" style="margin-top:5px"/>
          <product-order-craft-info ref="craftInfo"/>
        </el-tab-pane>
        <el-tab-pane :label="machineLabel" name="second">
          <product-order-machine-info ref="machineInfo" :productOrderLength="productOrderLen"/>
        </el-tab-pane>
    </el-tabs>
    <div class="footer">
      <el-button type="primary" @click="activeName = 'second'" v-show="activeName == 'first'">下一步</el-button>
      <el-button type="primary" @click="creatProductOrder" v-show="activeName == 'second'">创建</el-button>
    </div>
  </div>
</template>

<script>
import { productOrderHeaderInfo, productOrderCraftInfo, productOrderMachineInfo } from './components'
let _this
export default {
  components: { productOrderHeaderInfo, productOrderCraftInfo, productOrderMachineInfo },
  data () {
    return {
      activeName: 'first',
      shouldCache: true,
      productOrderLen: 0,
      machineLabel: '机台项'
    }
  },
  methods: {
    // 创建生产单
    creatProductOrder() {
      // 判定生产单头部与工艺单是否都填好了
      if (!this.$refs.orderHeaderInfo.getValid() || !this.$refs.craftInfo.getValid()) {
        this.activeName = 'first'
        return
      }
      const craftOrder = this.$refs.craftInfo.getCraftOrder()
      if (this.utils.isEmpty(craftOrder.craftItems)) {
        this.$Message.error('工艺项尚未填写！')
        this.activeName = 'first'
        return
      }
      const machineItems = this.$refs.machineInfo.getMachineItems()
      if (machineItems === false) {
        this.$Message.error('机台米数总和超过订单数量!')
        return false
      }
      if (this.utils.isEmpty(machineItems)) {
        this.$Message.error('还未选择需要生产的机台！')
        return
      }
      const productOrderHeader = this.$refs.orderHeaderInfo.getProductOrderHeader()
      productOrderHeader.fabricName = craftOrder.orderName
      const productOrder = {
        productOrderHeader: productOrderHeader,
        craftOrder: craftOrder,
        workOrders: machineItems
      }
      this.$requestBase({
        url: 'v1/factory/product-order/create',
        method: 'POST',
        data: productOrder
      }, true).then(res => {
        this.$Message.success(res.info)
        this.shouldCache = false
        this.$router.push('/product/productOrderList')
      })
    }
  },
  created () {
    _this = this
  },
  mounted () {
    // 这里对内容用vuex做了缓存，其实应该用keepalive的，后面才想起来。
    const orderCache = this.$store.state.productOrder.orderCache
    if (!this.utils.isEmpty(orderCache)) {
      this.$refs.orderHeaderInfo.productOrderHeader = orderCache.productOrderHeader
      this.$refs.craftInfo.craftOrder = orderCache.craftOrder
    }
    // 不管是否为空，都需去请求机台的数据
    this.$refs.machineInfo.getMachineList(orderCache.machineList).then(res => {
        if (!this.utils.isEmpty(orderCache.multipleSelection)) {
          this.$refs.machineInfo.toggleSelection(orderCache.multipleSelection)
        }
    })
  },
  beforeDestroy () {
    // 判断当前页面中的数据是否应该被缓存，如果创建生产单成功则不缓存
    if (this.shouldCache) {
      const orderCache = {
        productOrderHeader: this.$refs.orderHeaderInfo.productOrderHeader,
        craftOrder: this.$refs.craftInfo.craftOrder,
        machineList: this.$refs.machineInfo.machineList,
        multipleSelection: this.$refs.machineInfo.multipleSelection
      }
      this.$store.commit('productOrder/setCache', orderCache)
    } else {
      this.$store.commit('productOrder/initCache')
    }
  },
  destroyed() {
  },
  filters: {
    toTime: function(value) {
      return _this.utils.timestampToTime(value).split(' ')[0]
    }
  },
  watch: {
    activeName(value) {
      // 这是监听是否切换到机台项
      // 然后把订单数量传过去
      if (value === 'second') {
        const amount = this.$refs.orderHeaderInfo.productOrderHeader.amount
        if (amount > 0) {
          this.productOrderLen = amount
          this.machineLabel = `机台项(订单数量:${amount})`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input {
  margin: 6px 10px 0px 0px;
  width: 220px
}
.el-tabs {
  margin:8px
}
.footer {
  float: right;
  margin: 0px 10px 10px 0px
}
</style>
